const page_mid_three_array = [
    {
        id: 1,
        alt: "Defina Sua Meta!",
        imgURL: "images/defina-sua-meta.png",
        text: "Defina Sua Meta!",
        text2: "Defina sua meta de treino e vamos atingi-la!"
    },
    {
        id: 2,
        alt: "Treine Duro Com a Gente!",
        imgURL: "images/treine-duro.png",
        text: "Treine Duro Com a Gente!",
        text2: "Vamos treinar duro e atingir essa meta!"
    },
    {
        id: 3,
        alt: "Veja os resultados!",
        imgURL: "images/veja-resultados.png",
        text: "Veja os Resultados!",
        text2: "Vamos juntos colher os resultados do seu treino!"
    },
];

export default page_mid_three_array;